const screenshotSettings = {
  default: {
    size: { x: 1280, y: 960 }
  },
  interiorSuggestion: {
    size: { x: 900, y: 1200 }
  },
  mobile: {
    size: { x: 640, y: 480 }
  },
  // Might change this but it's the same now
  // Beware of changing this, you will probably also have to change svg text sizes etc...
  assemblySingleFrame: {
    size: { x: 640, y: 480 }
  }
};

export default screenshotSettings;
